export const ArrowOutwardIcon = ({ color = "#FFFFFF", size = 20, ...props }) => (
    <svg
        width={size}
        height={size * (21 / 20)}
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#arrow-outward-clip)">
            <path
                d="M5.00033 5.5V7.16667H12.1587L4.16699 15.1583L5.34199 16.3333L13.3337 8.34167V15.5H15.0003V5.5H5.00033Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="arrow-outward-clip">
                <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </svg>
);
